import { useState } from 'react';
import styled from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { meta } from '@happymoneyinc/meta';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import Link from '../Link/Link.js';
import SvgIcon from '../SvgIcon/SvgIcon.js';

const Alert = props => {
  const {
    children,
    className,
    dismissible,
    testID,
    type
  } = props;
  const [isClosed, setIsClosed] = useState(false);
  const onClose = () => {
    setIsClosed(true);
  };
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: !isClosed && /*#__PURE__*/jsxs(AlertContainer, {
      type: type,
      className: className,
      "data-testid": testID,
      children: [/*#__PURE__*/jsxs(AlertContent, {
        children: [/*#__PURE__*/jsx(StyledIcon, {
          type: type,
          fill: meta.colors.black
        }), children]
      }), dismissible && /*#__PURE__*/jsx(Link, {
        onClick: onClose,
        element: "button",
        children: /*#__PURE__*/jsx(SvgIcon, {
          type: "close"
        })
      })]
    })
  });
};
const boxShadowColors = {
  alert: meta.colors.systemRed,
  info: meta.colors.flamingo[3],
  success: meta.colors.systemGreen,
  warning: meta.colors.systemYellow
};
const AlertContainer = styled.div`
  border: 2px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.black;
}};
  box-shadow: ${_ref2 => {
  let {
    theme,
    type
  } = _ref2;
  return `${theme.globals.boxShadowSizes.normal} ${boxShadowColors[type]}`;
}};
  display: flex;
  justify-content: space-between;
  padding: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return `${theme.spacing[3]} ${theme.spacing[5]}`;
}};
  position: relative;
  width: 100%;
`;
const StyledIcon = styled(SvgIcon)`
  margin-right: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing[4];
}};
  min-width: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing[4];
}};
`;
const AlertContent = styled.div`
  align-items: center;
  display: flex;
`;
Alert.defaultProps = {
  children: null,
  className: '',
  dismissible: true,
  testID: 'alert',
  type: 'info'
};
Alert.propTypes = {
  /** Content to be displayed inside the alert component */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /** @ignore */
  className: PropTypes.string,
  /** Controls whether to show the 'X' which allows the closing of the alert */
  dismissible: PropTypes.bool,
  /** Passes in a data-testid */
  testID: PropTypes.string,
  /** Change the icon and shadow color */
  type: PropTypes.oneOf(['info', 'alert', 'success', 'warning'])
};
var Alert$1 = Alert;

export { Alert$1 as default };
//# sourceMappingURL=Alert.js.map
